import { useState } from 'react'
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom'
import {
  Activity, BarChart3, BookOpen, Building2, CalendarCheck, ChevronLeft, DatabaseZap,
  FileText, Gauge, LayoutDashboard, LogOut, Mail, Menu, Megaphone, PanelRightClose,
  SearchCheck, Send, Settings2, ShieldCheck, Target, Users, X,
} from 'lucide-react'
import { auth } from '../lib/api'
import { useApp } from '../context/AppContext'

const groups = [
  { title: 'غرفة العمليات', items: [
    ['/', 'نظرة تنفيذية', LayoutDashboard, 'sponsorship.view'], ['/tasks', 'المهام والمتابعات', CalendarCheck, 'sponsorship.view'], ['/analytics', 'التحليلات الشاملة', BarChart3, 'analytics.view'],
  ]},
  { title: 'الرعايات', items: [
    ['/leads', 'فرص الرعاية', Users, 'sponsorship.view'], ['/studies', 'الدراسات والملفات', BookOpen, 'sponsorship.view'],
  ]},
  { title: 'مركز الاستهداف', items: [
    ['/companies', 'الشركات المستهدفة', Building2, 'targeting.view'], ['/enrichment', 'إثراء صناع القرار', DatabaseZap, 'targeting.view'],
  ]},
  { title: 'التواصل الخارجي', items: [
    ['/templates', 'قوالب الرسائل', FileText, 'outreach.view'], ['/campaigns', 'الحملات البريدية', Send, 'outreach.view'], ['/outreach', 'أداء التواصل', Activity, 'outreach.view'], ['/deliverability', 'سلامة الإرسال', ShieldCheck, 'outreach.view'],
  ]},
  { title: 'التسويق والأداء', items: [
    ['/ads', 'تقارير الإعلانات', Megaphone, 'analytics.view'], ['/attribution', 'المصادر والإسناد', SearchCheck, 'analytics.view'], ['/integrations', 'التكاملات', Settings2, 'analytics.view'],
  ]},
] as const

export default function AppShell() {
  const [open, setOpen] = useState(false)
  const app = useApp()
  const navigate = useNavigate()
  const location = useLocation()
  const logout = async () => { await auth.logout(); navigate('/login') }

  return <div className="app-shell">
    <button className="mobile-menu" onClick={() => setOpen(true)} aria-label="فتح القائمة"><Menu /></button>
    {open && <button className="sidebar-backdrop" onClick={() => setOpen(false)} aria-label="إغلاق القائمة" />}
    <aside className={`sidebar ${open ? 'is-open' : ''}`}>
      <div className="brand">
        <div className="brand-mark"><Target /></div>
        <div><strong>منصة دراية 3</strong><span>إدارة الرعايات والاستهداف</span></div>
        <button className="sidebar-close" aria-label="إغلاق القائمة" onClick={() => setOpen(false)}><X /></button>
      </div>
      <div className="program-chip"><span>الأسبوع التنفيذي</span><strong>{Math.min(18, Math.max(1, Math.floor((Date.now() - new Date(app.program.starts_on).getTime()) / 604800000) + 1))} / 18</strong></div>
      <nav>
        {groups.map((group) => {
          const items = group.items.filter(([, , , permission]) => app.permissions.includes(permission))
          return items.length > 0 && <div className="nav-group" key={group.title}><p>{group.title}</p>
            {items.map(([to, label, Icon]) => <NavLink key={to} to={to} end={to === '/'} onClick={() => setOpen(false)} className={({ isActive }) => isActive ? 'active' : ''}><Icon size={18} /><span>{label}</span><ChevronLeft size={14} /></NavLink>)}
          </div>
        })}
      </nav>
      <footer className="sidebar-user">
        <div className="avatar">{app.user.name.slice(0, 1)}</div><div><strong>{app.user.name}</strong><span>{app.user.email}</span></div>
        <button onClick={logout} title="تسجيل الخروج"><LogOut size={18} /></button>
      </footer>
    </aside>
    <main className="main-area">
      <div className="topbar">
        <div><PanelRightClose size={19} /><span>مؤسسة صيتة × ملتقى دراية</span></div>
        <div className="topbar-actions"><a href={import.meta.env.VITE_LANDING_URL || 'https://diraya3.hekayet-hadaf.com'} target="_blank" rel="noreferrer"><Gauge size={17} /> صفحة التسجيل</a><a href="mailto:partnerships@hekayet-hadaf.com"><Mail size={17} /> partnerships@hekayet-hadaf.com</a></div>
      </div>
      <div className="content" key={location.pathname}><Outlet /></div>
    </main>
  </div>
}
